import { useEffect, useRef } from 'react';

const useOnMount = (callBack, dependencies = []) => {
    const isFirstRender = useRef(true);

    useEffect(() => {

        if (isFirstRender.current) {
            isFirstRender.current = false;
            return callBack();
        }

        return;
    }, dependencies);
};

export default useOnMount;
